export default __webpack_public_path__ + "static/media/plantation_worker_white.6fece0fd.svg";